import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { SERVER_URL } from '../../utils/api';
import '../../styles/meetings.css';

/**
 * Somebody's picture - for a tile whose camera is off, and in the list of people.
 *
 * An employee's is their portal profile picture. An outside guest's is their
 * public picture for their email address, if there is one (Gravatar; see
 * server/utils/meetingGuests.js). Where there is none - or it fails to load - a
 * plain person icon is shown, never initials and never a broken image.
 *
 * Only two kinds of address are ever fetched: a path on this server, and
 * Gravatar. Whatever else turns up in a participant's details is ignored.
 */

const GRAVATAR = 'https://www.gravatar.com/avatar/';

/** The address to load, or '' when there is nothing safe to show. */
export const photoUrl = (source) => {
    if (typeof source !== 'string' || !source) return '';
    if (source.startsWith(GRAVATAR)) return source;
    if (source.startsWith('/') && !source.startsWith('//')) return `${SERVER_URL}${source}`;
    return '';
};

const MeetingPhoto = ({ src, name = '', className = '' }) => {
    const [failed, setFailed] = useState(false);
    const url = photoUrl(src);

    // A different person in the same tile gets a fresh try.
    useEffect(() => { setFailed(false); }, [url]);

    if (url && !failed) {
        return (
            <img
                className={className}
                src={url}
                alt={name}
                title={name}
                referrerPolicy="no-referrer"
                style={{ objectFit: 'cover' }}
                onError={() => setFailed(true)}
            />
        );
    }

    return (
        <span className={`${className} mt-photo-fallback`} role="img" aria-label={name || 'Participant'} title={name}>
            <FontAwesomeIcon icon={faUser} />
        </span>
    );
};

export default MeetingPhoto;
